import React from 'react';
import { StarIcon } from 'lucide-react';
import { TESTIMONIALS } from '../lib/content';
export function Testimonials() {
  return <div className="space-y-3" data-id="element-178">
      {TESTIMONIALS.map((t, i) => <div key={i} className="rounded-xl border border-orange-500/25 bg-neutral-900/80 p-4 backdrop-blur-sm" data-id="element-179">
          <div className="flex items-start gap-3" data-id="element-180">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-orange-500/20 font-display text-lg text-orange-400" data-id="element-181">
              {t.name.replace('Coach ', '').charAt(0)}
            </div>
            <div className="min-w-0 flex-1" data-id="element-182">
              <div className="flex items-center gap-1" data-id="element-183">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-orange-400 text-orange-400" data-id="element-184" />)}
              </div>
              <p className="mt-1.5 text-sm leading-relaxed text-neutral-200" data-id="element-185">
                “{t.text}”
              </p>
              <p className="mt-2 text-xs font-semibold text-white" data-id="element-186">{t.name}</p>
              <p className="text-[11px] text-neutral-400" data-id="element-187">
                {t.role} · {t.location}
              </p>
            </div>
          </div>
        </div>)}
    </div>;
}